/**
 * Keyboard Shortcuts Help Modal
 *
 * Displays available keyboard shortcuts when user presses "?"
 */

import { Modal, Typography, Space, Tag, Divider } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

interface KeyboardShortcutsHelpProps {
  open: boolean;
  onClose: () => void;
}

const ShortcutItem = ({ shortcut, description }: { shortcut: string; description: string }) => (
  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0' }}>
    <Text>{description}</Text>
    <Tag style={{ fontFamily: 'monospace', fontSize: 13 }}>{shortcut}</Tag>
  </div>
);

export default function KeyboardShortcutsHelp({ open, onClose }: KeyboardShortcutsHelpProps) {
  return (
    <Modal
      title={
        <Space>
          <QuestionCircleOutlined />
          <span>Keyboard Shortcuts</span>
        </Space>
      }
      open={open}
      onCancel={onClose}
      footer={null}
      width={500}
    >
      <div style={{ maxHeight: 400, overflow: 'auto' }}>
        <Title level={5} style={{ marginTop: 0 }}>Global</Title>
        <ShortcutItem shortcut="⌘/Ctrl + K" description="Open search" />
        <ShortcutItem shortcut="⌘/Ctrl + N" description="Create new item" />
        <ShortcutItem shortcut="Shift + ?" description="Show this help" />

        <Divider />

        <Title level={5}>Editor</Title>
        <ShortcutItem shortcut="⌘/Ctrl + S" description="Save changes" />
        <ShortcutItem shortcut="Escape" description="Close drawer/modal" />

        <Divider />

        <Title level={5}>Search</Title>
        <ShortcutItem shortcut="↑ / ↓" description="Navigate results" />
        <ShortcutItem shortcut="Enter" description="Select result" />
        <ShortcutItem shortcut="Escape" description="Close search" />

        <Divider />

        <Title level={5}>Rich Text Editor</Title>
        <ShortcutItem shortcut="/" description="Open slash commands" />
        <ShortcutItem shortcut="⌘/Ctrl + B" description="Bold" />
        <ShortcutItem shortcut="⌘/Ctrl + I" description="Italic" />
        <ShortcutItem shortcut="⌘/Ctrl + U" description="Underline" />
      </div>

      <div style={{ marginTop: 16, textAlign: 'center' }}>
        <Text type="secondary" style={{ fontSize: 12 }}>
          Press <Tag style={{ fontSize: 11 }}>Escape</Tag> to close
        </Text>
      </div>
    </Modal>
  );
}
